/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import find from 'lodash/find';
import {
    selectFeatureFlags,
    selectIsMobilePDPImageZoomed,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { selectQueryParams } from 'yoda-site-components/lib/selectors/QuerySelector';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import selectLazy from 'yoda-site-components/lib/lazy/selectors/selectLazy';
import SavedListToolTip from 'yoda-site-components/lib/components/SavedListToolTip/SavedListToolTipLazy';
import { updateItems } from 'yoda-site-components/lib/actions/MiniPDPAction';
import { getSavedItems } from 'yoda-site-components/lib/actions/SavedItemAction';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import HeartRed from 'yoda-core-components/lib/assets/svg/wishlist-filled-red.svg';
import HeartWhite from 'yoda-core-components/lib/assets/svg/wishlist-Outline-black.svg';
import BackgroundClose from 'yoda-site-components/lib/components/BackgroundClose/BackgroundClose';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './AddToList.css';
import signinFrom from '../../actions/SignInSliderAction';

const cx = classNames.bind(styles);

const getSkuIdForItem = (optionsSelected, dimensions, filteredItems) => {
    let skuId = null;
    /* istanbul ignore else */
    if (optionsSelected.length > 0 && filteredItems.length) {
        if (filteredItems.length === 1) {
            skuId = filteredItems[0].id;
        } else {
            const availableFilteredItems = find(filteredItems, { atp: true });
            if (availableFilteredItems) {
                skuId = availableFilteredItems.id;
                /* istanbul ignore else */
            } else {
                skuId = filteredItems[0].id;
            }
        }
    }
    return skuId;
};
const favoriteTooltipStyle = dt([
    'text-sm',
    'font-open-sans-bold',
    'leading-[1.71]',
    'text-center',
    'text-black',
    'absolute',
    'bg-white',
    'shadow-elevation1',
    'py-2',
    'px-4',
    'rounded',
    'border',
    'border-solid',
    'border-gray-25',
    'z-[5]',
    'right-0',
    'top-12',
    'after:block',
    'after:absolute',
    'after:w-0',
    'after:h-0',
    'after:border-solid',
    'after:border-transparent',
    'after:border-[10px]',
    'after:-top-2.5',
    'after:-ml-2.5',
    'after:border-t-0',
    'after:border-b-white',
    'after:right-[9px]',
    'after:z-[2]',
    'before:block',
    'before:absolute',
    'before:w-0',
    'before:h-0',
    'before:border-solid',
    'before:border-transparent',
    'before:border-[10px]',
    'before:-top-2.5',
    'before:-ml-2.5',
    'before:border-t-0',
    'before:border-b-black',
    'before:right-[9px]',
    'before:z-[2]',
]);

export class AddToList extends SiteComponent {
    constructor() {
        super();
        this.addToListClick = this.addToListClick.bind(this);
        this.updateItemClick = this.updateItemClick.bind(this);
        this.state = {
            showTooltip: false,
            showUpdatedItemTooltip: false,
            showRedIcon: false,
            addToListPayLoad: [],
            updatedItem: {},
            listAddedSuccess: false,
            isFavTooltip: false,
            hideFavicon: false,
        };
    }

    static propTypes = {
        selectedQuantity: PropTypes.number,
        savedItems: PropTypes.oneOfType([PropTypes.object]),
        authenticationSuccess: PropTypes.bool,
        signinSliderFrom: PropTypes.string,
        isSigninSlider: PropTypes.bool,
        queryParams: PropTypes.oneOfType([PropTypes.object]),
        productDetails: PropTypes.oneOfType([PropTypes.object]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        congruentSelected: PropTypes.oneOfType([PropTypes.object]),
        accounts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        isMobilePDPImageZoomed: PropTypes.bool,
    };

    static defaultProps = {
        selectedQuantity: 1,
        savedItems: {},
        authenticationSuccess: false,
        signinSliderFrom: '',
        isSigninSlider: false,
        queryParams: {},
        productDetails: {},
        featureFlags: {},
        congruentSelected: {},
        accounts: {
            userProfile: {
                firstName: null,
                accountId: null,
                rewardsStatus: null,
                userState: null,
                totalCerts: null,
            },
        },
        isMobilePDPImageZoomed: false,
    };

    componentWillReceiveProps(nextProps) {
        const {
            authenticationSuccess,
            isSigninSlider,
            signinSliderFrom,
            accounts,
            congruentSelected,
            isMobilePDPImageZoomed,
        } = this.props;
        const { ppId, savedItems } = nextProps;
        const isUserLoggedIn = get(accounts, 'userProfile.userState', '0') !== '0';
        const isUserLoggedInNextProps =
            get(nextProps.accounts, 'userProfile.userState', '0') !== '0';
        if (!isEmpty(accounts) && !isUserLoggedIn && isUserLoggedInNextProps) {
            this.props.actions.getSavedItems &&
                this.props.actions.getSavedItems({ forceGetSavedItems: true });
        }
        /* istanbul ignore next */
        if (
            authenticationSuccess &&
            signinSliderFrom === 'addToList' &&
            isSigninSlider !== nextProps.isSigninSlider
        ) {
            this.setState({
                showTooltip: true,
            });
        }

        if (
            ppId &&
            savedItems &&
            Object.keys(congruentSelected).length > 0 &&
            congruentSelected?.isCongruent
                ? savedItems[ppId]?.id === ppId
                : savedItems[ppId]
        ) {
            this.isListAdded(true);
        } else {
            this.isListAdded(false);
        }

        if (get(nextProps, 'updatedItem')) {
            this.setState({
                updatedItem: nextProps.updatedItem,
            });
        }
        /* istanbul ignore next */
        if (nextProps.isMobilePDPImageZoomed !== isMobilePDPImageZoomed) {
            this.setState({
                hideFavicon: nextProps.isMobilePDPImageZoomed,
            });
        }
    }

    componentDidMount() {
        if (!__SERVER__) {
            this.props.actions.getSavedItems({ forceGetSavedItems: true });
        }
    }

    isUpdateItem = () => {
        const {
            queryParams,
            pageMounted,
            productOptions: { optionsSelected, dimensions, filteredItems },
        } = this.props;
        const itemId = getSkuIdForItem(optionsSelected, dimensions, filteredItems);
        if (itemId) {
            queryParams.selectedSKUId = itemId;
            const facetSelected = optionsSelected.map((item) => item.dimensionName).join();
            if (facetSelected) {
                queryParams.facetSelected = facetSelected;
            }
        }
        return (
            queryParams.uuid &&
            queryParams.listid &&
            queryParams.listname &&
            queryParams.selectedSKUId &&
            queryParams.facetSelected &&
            pageMounted
        );
    };

    updateList = () => {
        const {
            productOptions: { optionsSelected, dimensions, filteredItems },
            queryParams: { uuid, listid },
            productDetails: { id },
            selectedQuantity,
        } = this.props;
        const itemId = getSkuIdForItem(optionsSelected, dimensions, filteredItems);
        const attributes = optionsSelected.length
            ? optionsSelected.map((options) => ({
                  type: options.type,
                  value: options.option,
              }))
            : [];
        this.props.actions.updateItems({
            itemId,
            itemUUId: uuid,
            listId: listid,
            skuId: itemId,
            ppId: id,
            quantity: selectedQuantity,
            product: {
                id,
            },
            attributes,
        });
        this.setState({
            showUpdatedItemTooltip: !this.state.showUpdatedItemTooltip,
        });
    };

    addToListClick() {
        this.setState({
            showTooltip: !this.state.showTooltip,
            isFavTooltip: false,
        });
    }

    updateItemClick() {
        this.setState({
            isFavTooltip: false,
            showUpdatedItemTooltip: !this.state.showUpdatedItemTooltip,
            updatedItem: {},
        });
    }

    isListAdded = (listAddedSuccess) => {
        this.setState({ listAddedSuccess });
    };

    favoriteTooltip = () => (
        <section className={cx('favoriteTooltip', favoriteTooltipStyle)}>
            <p>Favorite</p>
        </section>
    );

    /* istanbul ignore next */
    onButtonMouseOver = () => {
        this.setState({ isFavTooltip: true });
    };

    /* istanbul ignore next */
    onButtonMouseOut = () => {
        this.setState({ isFavTooltip: false });
    };

    addToListSuccess = () => {
        this.props.actions.getSavedItems({ forceGetSavedItems: true });
    };

    render() {
        const {
            ppId,
            deviceType,
            selectedQuantity,
            actions,
            productOptions: { optionsSelected, dimensions, filteredItems },
            queryParams,
            isMobilePDPImageZoomed,
        } = this.props;
        const {
            updatedItem,
            listAddedSuccess,
            showTooltip,
            showUpdatedItemTooltip,
            isFavTooltip,
            hideFavicon,
        } = this.state;
        const itemId = getSkuIdForItem(optionsSelected, dimensions, filteredItems);
        const attributes = optionsSelected.length
            ? optionsSelected.map((options) => ({
                  type: options.type,
                  value: options.option,
              }))
            : [];
        /* istanbul ignore next */
        const addToListPayLoad = [
            {
                product: {
                    id: ppId,
                },
                itemId,
                quantity: selectedQuantity,
                attributes,
            },
        ];
        const updateItem = this.isUpdateItem();
        const addToListBlockStyle = dt(['absolute', 'z-1', 'right-0', 'top-0']);
        const heartIconButtonStyle = dt([
            'lg:w-10',
            'lg:h-10',
            'smMd:w-7',
            'smMd:h-7',
            'absolute',
            'z-[3]',
            'pointer-events-["all"]',
            'mt-1',
            'mr-1',
            'mb-0',
            'ml-0',
            'right-0',
            'top-0',
        ]);

        /* istanbul ignore next */
        return (
            <section
                className={cx('addToListBlock', addToListBlockStyle, {
                    addToListTooltip: showTooltip,
                })}
            >
                <BackgroundClose
                    closeModal={updateItem ? this.updateItemClick : this.addToListClick}
                    isModalOpen={showTooltip || showUpdatedItemTooltip}
                    render={() => (
                        <>
                            {showTooltip ? (
                                <SavedListToolTip
                                    automationId="test-automation-search"
                                    deviceType={deviceType}
                                    productId={ppId}
                                    pdpPayload={addToListPayLoad}
                                    origin="PDP"
                                    headerText="Select List to Add"
                                    handleCreateNewList={() => {}}
                                    closeToolTip={this.addToListClick}
                                    signinFrom={actions.signinFrom}
                                    isListAdded={this.isListAdded}
                                    addToListSuccess={this.addToListSuccess}
                                />
                            ) : (
                                ''
                            )}
                            {showUpdatedItemTooltip ? (
                                <SavedListToolTip
                                    automationId="test-automation-search"
                                    deviceType={deviceType}
                                    productId={ppId}
                                    pdpPayload={addToListPayLoad}
                                    origin="PDP"
                                    headerText=""
                                    handleCreateNewList={() => {}}
                                    updatedItem={updatedItem}
                                    updatedListName={get(queryParams, 'listname', '')}
                                    listId={get(queryParams, 'listid', '')}
                                    closeToolTip={this.updateItemClick}
                                    signinFrom={actions.signinFrom}
                                    isListAdded={this.isListAdded}
                                    addToListSuccess={this.addToListSuccess}
                                />
                            ) : (
                                ''
                            )}
                        </>
                    )}
                />
                {!hideFavicon && (
                    <button
                        className={cx('heartIconButton', heartIconButtonStyle)}
                        data-automation-id="heartIcon"
                        onMouseOver={this.onButtonMouseOver}
                        onMouseOut={this.onButtonMouseOut}
                        onClick={updateItem ? this.updateList : this.addToListClick}
                    >
                        <Icon
                            iconType="svg"
                            className={cx('svg-icon')}
                            width={dt(['lg:w-10', 'smMd:w-7'])}
                            height={dt(['lg:w-10', 'smMd:w-7'])}
                            viewBox={!deviceType.isMobile ? '0 0 40 40' : '0 0 28 28'}
                        >
                            {listAddedSuccess || updateItem ? <HeartRed /> : <HeartWhite />}
                        </Icon>
                    </button>
                )}

                {!deviceType.isMobile && isFavTooltip && this.favoriteTooltip()}
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    deviceType: state.context ? state.context.deviceType : {},
    selectedQuantity: parseInt(state.selectedQuantity, 10),
    productOptions: initProductOptions(false)(state),
    productDetails: state.productDetails,
    savedItems: state.savedItems,
    authenticationSuccess:
        state.signInSliderDetails && state.signInSliderDetails.authenticationSuccess,
    signinSliderFrom:
        state.signInSliderFrom && state.signInSliderFrom.clickFrom
            ? state.signInSliderFrom.clickFrom
            : '',
    isSigninSlider: (state.accounts && state.accounts.openSignInSlider) || false,
    queryParams: selectQueryParams(state),
    pageMounted: selectLazy(state).pageMounted || false,
    updatedItem: state.miniPDP && state.miniPDP.updatedItem,
    featureFlags: selectFeatureFlags(state),
    congruentSelected: state.congruentSelected || {},
    accounts: state.accounts || {
        userProfile: {
            firstName: null,
            accountId: null,
            rewardsStatus: null,
            userState: null,
            totalCerts: null,
        },
    },
    isMobilePDPImageZoomed: selectIsMobilePDPImageZoomed(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            signinFrom,
            updateItems,
            getSavedItems,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddToList);
